import React from 'react';
import { Link } from 'react-router-dom';

function MetricCard({ label, value, href = null, hint = null }) {
  const inner = (
    <>
      <div className="text-muted small">{label}</div>
      <div className="h4 mb-0">{value ?? 0}</div>
      {hint ? <div className="small text-muted mt-1">{hint}</div> : null}
    </>
  );
  if (href) {
    return (
      <Link to={href} className="product-card d-block text-decoration-none text-body h-100 mb-0">
        {inner}
      </Link>
    );
  }
  return <div className="product-card mb-0 h-100">{inner}</div>;
}

export default MetricCard;
